import React from "react";
import {getFunName} from '../helpers';
import { tonavigate } from "./tonavigate";
import PropTypes from "prop-types";

class StorePicker extends React.Component 
{

  static propTypes =  
  {
    history: PropTypes.object
  };

  myInput=React.createRef(); //to create a refrence to input box in order to take its value

  gotostore=(event)=>
  {
   event.preventDefault(); //to stop the default action of form- from refreshing
   console.log(this.myInput.current.value); //getting the store name
  const storename=this.myInput.current.value;
  const {navigate}=this.props; // navigate was added as a prop to this component by tonavigate method, hence we can navigate to specific url
  navigate(`/store/${storename}`);
  }

  render()
   {
    return(
    
      <form className="store-selector" onSubmit={this.gotostore}>
      {/*always put comments inside of the element tag*/}
        <h2>Please enter the store</h2>
        <input type="text"
        ref={this.myInput} 
        required placeholder="Store Name" defaultValue={getFunName()} ></input>
        <button type="submit">Visit Store</button>
      </form>
    );
  }
}

export default tonavigate(StorePicker); // to add the navigation propertery to this function